import { call, all }      from 'redux-saga/effects';
import getUserInfo        from './get_user_info';
import getUserActivity    from './get_user_activity';
import getTotalLikes      from './get_total_likes';
import updateUserActivity from './update_user_activity';
import getContent         from './get_content';
import getTeacherContent  from './get_teacher_content';
import getGroupContent    from './get_group_content';
import getStudentScores   from './get_student_scores';
import getGroupLessons    from './get_group_lessons';
import getUserLessons     from './get_user_lessons';
import getUserVideos      from './get_user_videos';
import getWhatsappStatus  from './whatsapp_reminder_status';
import getFatherApp       from './get_father_app';
import whatsappUpdate     from './whatsapp_reminder_update';
import getTutorials       from './get_tutorials';
import registerEmail      from './register_email';
import joinLesson         from './join_lesson';
import submitMessage      from './submit_message';
import createData         from './create_data';
import recordError        from './record_error';
import recordLrsEvent     from './record_lrs_event';
import recordUserLogin    from './record_user_login';
import updateApproved     from './update_approved';
import saveVideoLocation  from './save_video_location';
import deleteUserVideo    from './delete_user_video';
import logOut             from './log_out';
import logIn              from './log_in';
import doTest             from './do_test';
import recordLogoutEvent  from './record_user_logout';



export default function* indexSaga(){
  yield all([
    call(recordLogoutEvent),
    call(getUserInfo),
    call(getContent),
    call(getTeacherContent),
    call(getGroupContent),
    call(getUserActivity),
    call(getTotalLikes),
    call(getTutorials),
    call(getStudentScores),
    call(getGroupLessons),
    call(getUserLessons),
    call(getUserVideos),
    call(getWhatsappStatus),
    call(getFatherApp),
    call(whatsappUpdate),
    call(registerEmail),
    call(joinLesson),
    call(submitMessage),
    call(createData),
    call(updateUserActivity),
    call(recordLrsEvent),
    call(recordUserLogin),
    call(recordError),
    call(updateApproved),
    call(saveVideoLocation),
    call(deleteUserVideo),
    call(logOut),
    call(logIn),
    call(doTest),
  ])
}